import React from 'react';

import { IQuickStartGuideBoxFields } from '../../../types/contentful';

import RichText from '../RichText';
import { Asset } from '../AtomicComponents/Asset';

export function QuickStartGuideBox({
  image,
  header,
  text
}: IQuickStartGuideBoxFields) {
  return (
    <div
      className="px-1 py-4 tablet:px-4 tablet:py-8"
      data-testid="quick-start-box"
    >
      {image && (
        <Asset
          asset={image}
          className="w-full overflow-hidden rounded-[56px]"
          sizes="(max-width: 720px) 100vw, 50vw"
        />
      )}
      <div className="-mt-12 rounded-none bg-[#F1F1F1] pb-12 pl-8 pr-8 pt-16 tablet:rounded-[56px] tablet:pb-12 tablet:pl-12 tablet:pr-12 tablet:pt-[84px] [&_li]:ml-4 tablet:[&_li]:-ml-2">
        <div className="pb-3">
          <h3 className="text-[22px] font-medium leading-6 tablet:text-[26px] tablet:leading-8">
            {header}
          </h3>
        </div>
        {text && <RichText data={text} />}
      </div>
    </div>
  );
}
